export default __webpack_public_path__ + "static/media/benefit_17.256d8c54.png";